export { default } from './shopHeroSlice';
